import { Link } from "react-router-dom";
import { useState, useEffect, useRef } from "react";
import SpinnerComponent from "../../components/atoms/spinner/spinner.component";
import ModalComponent from "../../components/atoms/modal/modal.component";
import FormInputFileUploadComponent from "../../components/atoms/form-input/form-input-file-upload/form-input-file-upload.component";

const HeaderTemplate = ({ templateData, templateEvent }) => {
  const {
    manufacturers,
    categories,
    loading,
    searchQuery,
    searchResults,
    showUploadModal,
    selectedFile,
    settings,
    isMobileCheck,
    cart,
    activeDropdown,
  } = templateData;
  const {
    handleSearch,
    handleFileUpload,
    setShowUploadModal,
    setSearchQuery,
    handleNavigateAccount,
    handleNavigateCart,
    handleMobile,
    handleNavigateInventory,
    setActiveDropdown,
  } = templateEvent;

  // Mobile: toggle open/close on click.
  const toggleDropdown = (dropdown) => {
    setActiveDropdown(activeDropdown === dropdown ? null : dropdown);
  };

  // Desktop hover: open on enter, close on leave. The dropdown menu is a child
  // of the nav item (with a small transparent bridge in CSS), so moving from
  // the link onto the menu keeps it open, and moving away closes it immediately.
  const handleNavEnter = (dropdown) => {
    if (!isMobileCheck) setActiveDropdown(dropdown);
  };
  const handleNavLeave = () => {
    if (!isMobileCheck) setActiveDropdown(null);
  };

  // ---- inline icons (thin-stroke, match the design system) ----
  const stroke = {
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  return (
    <header id="header" className="ds-header">
      {/* Top utility bar */}
      <div className="ds-topbar">
        <div className="ds-container ds-topbar-inner">
          <div className="ds-row" style={{ gap: 16 }}>
            <span className="ds-t-item">
              <svg width="14" height="14" viewBox="0 0 24 24" {...stroke}>
                <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.36 1.9.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.9.34 1.85.57 2.81.7A2 2 0 0 1 22 16.92Z" />
              </svg>
              +91 9902099933
            </span>
          </div>
          <div className="ds-row" style={{ gap: 12 }}>
            <span className="ds-t-item">
              <img src="/assets/img/flag-icon.png" alt="Flag" style={{ height: 14 }} />
              &nbsp;₹ INR
            </span>
          </div>
        </div>
      </div>

      {/* Branding + search */}
      <div className="ds-branding-wrap">
        <div className="ds-container ds-branding">
          {settings && (
            <Link to="/" className="ds-logo" key={settings?.header_logo}>
              <img src={settings?.header_logo} alt="Logo" />
            </Link>
          )}

          <div className="ds-search" style={{ position: "relative" }}>
            <form
              className="ds-search"
              style={{ width: "100%" }}
              onSubmit={(e) => {
                e.preventDefault();
                handleSearch();
              }}
            >
              <div className="ds-search-field">
                <span className="lead">
                  <svg width="18" height="18" viewBox="0 0 24 24" {...stroke}>
                    <circle cx="11" cy="11" r="8" />
                    <path d="m21 21-4.3-4.3" />
                  </svg>
                </span>
                <input
                  type="text"
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  placeholder="Search by part number, keyword or MPN…"
                />
                {searchQuery && (
                  <button
                    type="button"
                    onClick={() => setSearchQuery("")}
                    className="icon-btn"
                    style={{ width: 32, height: 32 }}
                    aria-label="Clear"
                  >
                    <svg width="16" height="16" viewBox="0 0 24 24" {...stroke}>
                      <circle cx="12" cy="12" r="10" />
                      <path d="m15 9-6 6M9 9l6 6" />
                    </svg>
                  </button>
                )}
                <button
                  type="button"
                  className="upload-link"
                  onClick={() => setShowUploadModal(true)}
                >
                  <svg width="15" height="15" viewBox="0 0 24 24" {...stroke}>
                    <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                    <polyline points="17 8 12 3 7 8" />
                    <line x1="12" y1="3" x2="12" y2="15" />
                  </svg>
                  Upload a list
                </button>
              </div>
              <button type="submit" className="ds-btn ds-btn-primary" onClick={handleSearch}>
                <svg width="16" height="16" viewBox="0 0 24 24" {...stroke}>
                  <circle cx="11" cy="11" r="8" />
                  <path d="m21 21-4.3-4.3" />
                </svg>
                <span className="ds-hide-sm">Search</span>
              </button>
            </form>

            {/* Live search results */}
            {searchResults.length > 0 && (
              <ul className="ds-navdrop" style={{ position: "absolute", top: "100%", left: 0, right: 0, marginTop: 6 }}>
                {searchResults.map((result, index) => (
                  <li key={index}>
                    <a>{result.name}</a>
                  </li>
                ))}
              </ul>
            )}
          </div>

          <div className="ds-header-actions">
            <button
              className="icon-btn"
              onClick={handleNavigateCart}
              aria-label="Cart"
              style={{ position: "relative" }}
            >
              <svg width="22" height="22" viewBox="0 0 24 24" {...stroke}>
                <circle cx="9" cy="21" r="1" />
                <circle cx="20" cy="21" r="1" />
                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
              </svg>
              {cart?.length > 0 && (
                <span className="ds-count-badge">{cart?.length}</span>
              )}
            </button>
            <button className="icon-btn" onClick={handleNavigateAccount} aria-label="Account">
              <svg width="22" height="22" viewBox="0 0 24 24" {...stroke}>
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
              </svg>
            </button>
          </div>
        </div>
      </div>

      {/* Primary nav */}
      <nav id="navmenu" className="ds-mainnav">
        <div className="ds-container ds-mainnav-inner">
          <button
            className="icon-btn ds-nav-toggle"
            onClick={handleMobile}
            aria-label="Menu"
          >
            <svg width="22" height="22" viewBox="0 0 24 24" {...stroke}>
              {isMobileCheck ? (
                <path d="M18 6 6 18M6 6l12 12" />
              ) : (
                <path d="M3 12h18M3 6h18M3 18h18" />
              )}
            </svg>
          </button>

          <div className={`ds-navlinks ${isMobileCheck ? "open" : ""}`}>
            {/* Products */}
            <div
              className="ds-navitem"
              onMouseEnter={() => handleNavEnter("categories")}
              onMouseLeave={handleNavLeave}
            >
              <a
                className={`ds-navlink ${activeDropdown === "categories" ? "active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  if (isMobileCheck) toggleDropdown("categories");
                }}
              >
                Products
                <svg className="chev" width="12" height="12" viewBox="0 0 24 24" {...stroke}>
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </a>
              {activeDropdown === "categories" && (
                <ul className="ds-navdrop">
                  {categories?.length > 0 ? (
                    categories?.map((category) => (
                      <li key={category.unique_id}>
                        <a onClick={() => handleNavigateInventory(category)}>
                          {category.name}
                        </a>
                      </li>
                    ))
                  ) : (
                    <li>
                      <a>No categories found</a>
                    </li>
                  )}
                </ul>
              )}
            </div>

            {/* Manufacturers */}
            <div
              className="ds-navitem"
              onMouseEnter={() => handleNavEnter("manufacturers")}
              onMouseLeave={handleNavLeave}
            >
              <a
                className={`ds-navlink ${activeDropdown === "manufacturers" ? "active" : ""}`}
                onClick={(e) => {
                  e.preventDefault();
                  if (isMobileCheck) toggleDropdown("manufacturers");
                }}
              >
                Manufacturers
                <svg className="chev" width="12" height="12" viewBox="0 0 24 24" {...stroke}>
                  <polyline points="6 9 12 15 18 9" />
                </svg>
              </a>
              {activeDropdown === "manufacturers" && (
                <ul className="ds-navdrop">
                  {manufacturers?.length > 0 ? (
                    manufacturers.map((manufacturer) => (
                      <li key={manufacturer.id}>
                        <Link to={`/manufacturer/${manufacturer.id}`}>
                          {manufacturer.manufacturer_name}
                        </Link>
                      </li>
                    ))
                  ) : (
                    <li>
                      <a>No manufacturers found</a>
                    </li>
                  )}
                </ul>
              )}
            </div>

            <Link className="ds-navlink" to="/request-quote" onClick={() => { setActiveDropdown(null); if (isMobileCheck) handleMobile(); }}>
              Request a Quote
            </Link>
          </div>
        </div>
      </nav>

      {/* Upload BOM modal */}
      <ModalComponent
        open={showUploadModal}
        handleClosePopup={() => setShowUploadModal(false)}
        title="Upload BOM File !!"
        primaryText="Upload"
        secondaryText="Cancel"
        secondaryAction={() => setShowUploadModal(false)}
        primaryAction={() => {
          const fileInput = document.getElementById("bomFileInput");
          if (fileInput && fileInput.files.length > 0) {
            handleFileUpload({ target: fileInput });
          } else {
            alert("Please select a file first");
          }
        }}
      >
        <FormInputFileUploadComponent
          name="bomFile"
          id="bomFileInput"
          handleUpload={() => {}}
        />
      </ModalComponent>
    </header>
  );
};

export default HeaderTemplate;
